// File: BaseIntegrationWebComponent.ts
import { Observable } from 'rxjs';
import { BaseWebComponentElement } from '../../framework/BaseWebComponentElement';
import { IntegrationActionContext } from '../integrationsMarketplaceGridInstalled/types';
import { Company } from '../../tagsManager/types/tag-data';
import { Integration, IntegrationData } from './types';

export abstract class BaseIntegrationWebComponent<IntegrationTypeSpecifics> extends BaseWebComponentElement {
  abstract get valid$(): Observable<boolean> | null;
  abstract get valid(): boolean;

  abstract get formContext(): IntegrationActionContext;

  abstract set formContext(context: IntegrationActionContext);

  abstract setActionContext(context: IntegrationActionContext): void;

  abstract setViewData(data: Integration | null): void;

  abstract getViewData(): Integration | null;

  abstract setCompany(company: Company);

  abstract setIntegrationId(id: string);

  abstract setIntegrationData(integration: IntegrationData<IntegrationTypeSpecifics>);
}
